export default "__VITE_ASSET__KAcD$aMb__"